export default "__VITE_ASSET__2eeda61f__"